export default "__VITE_ASSET__CDQ3JoPw__"